/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {NGX_STRIPE_VERSION as ɵa} from './lib/interfaces/ngx-stripe.interface';